import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Spinner } from 'reactstrap'

import { getUserAlias } from 'models/ProfileInfo/selectors'
import { COLOURS, STRING } from 'resources'
import { checkCircleGreen, exclamationOrange, warningCircleRed } from 'resources/images'
import { getReklaimProtectBreachData } from 'services/reklaimProtect'

import DataBreachItem from './DataBreachItem'
import {
  Container,
  SpinnerContainer,
  TitleContainer,
  IconContainer,
  Icon,
  Title,
  GreyTitle,
  Description,
  ItemWrapper,
  SeeMoreButton,
} from './styles'

const INITIAL_VISIBLE = 5

const BreachStatus = ({ setBreachCount }) => {
  const userAlias = useSelector(getUserAlias)
  const [breachData, setBreachData] = useState(null)
  const [showAll, setShowAll] = useState(false)

  const breachCount = breachData?.dataBreaches?.length ?? -1
  const hasBreaches = breachCount > 0

  const fetchBreachData = useCallback(async () => {
    const protectBreachData = await getReklaimProtectBreachData(userAlias)

    if (protectBreachData?.dataBreaches) {
      setBreachCount(protectBreachData.dataBreaches.length)
    }
    setBreachData(protectBreachData)
  }, [userAlias, setBreachCount, setBreachData])

  useEffect(() => {
    fetchBreachData()
  }, [fetchBreachData])

  let content
  if (!breachData) {
    content = (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    )
  } else if (breachCount >= 0) {
    content = (
      <>
        <TitleContainer>
          <IconContainer color={hasBreaches ? COLOURS.systemOrange2 : COLOURS.systemGreen2}>
            <Icon src={hasBreaches ? exclamationOrange : checkCircleGreen} />
          </IconContainer>
          <Title>
            {STRING.protect.breachStatus.titleBreaches(breachCount)}
            <GreyTitle>{STRING.protect.breachStatus.titleFound}</GreyTitle>
          </Title>
        </TitleContainer>
        <Description>
          {hasBreaches
            ? STRING.protect.breachStatus.description(breachCount)
            : STRING.protect.breachStatus.descriptionAllClear}
        </Description>
        {hasBreaches && (
          <>
            {(showAll ? breachData.dataBreaches : breachData.dataBreaches.slice(0, INITIAL_VISIBLE)).map((breach) => (
              <ItemWrapper key={breach.breachName}>
                <DataBreachItem breach={breach} />
              </ItemWrapper>
            ))}

            {breachCount > INITIAL_VISIBLE && !showAll && (
              <SeeMoreButton onClick={() => setShowAll(true)}>{STRING.protect.breachStatus.seeMore}</SeeMoreButton>
            )}
          </>
        )}
      </>
    )
  } else {
    content = (
      <TitleContainer>
        <IconContainer color={COLOURS.secondaryRed2}>
          <Icon src={warningCircleRed} />
        </IconContainer>
        <Description>{STRING.protect.breachStatus.descriptionError}</Description>
      </TitleContainer>
    )
  }

  return <Container>{content}</Container>
}

BreachStatus.propTypes = {
  setBreachCount: PropTypes.func.isRequired,
}

export default BreachStatus
